"use strict";

import { useCallback } from 'react';
import { useFlixApiContext } from '../../FlixApiContext';
export var usePwdResetRequestMutation = function usePwdResetRequestMutation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onCompleted = _ref.onCompleted,
      onError = _ref.onError;

  var _useFlixApiContext = useFlixApiContext(),
      flixApiV2 = _useFlixApiContext.flixApiV2;

  return [useCallback(function (data) {
    return flixApiV2('post', 'member/password/request-reset', data).then(function () {
      return onCompleted && onCompleted();
    }).catch(function (error) {
      return onError ? onError(error) : Promise.reject(error);
    });
  }, [flixApiV2, onCompleted, onError])];
};